import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { TrashCanIcon } from '@skbkontur/icons/icons/TrashCanIcon';
import { Button, Gapped, Modal, SidePage } from '@skbkontur/react-ui';
import { IdentityDocumentForm } from '../IdentityDocumentForm';
import classes from './IdentityDocumentSidePage.module.css';
export const IdentityDocumentSidePage = ({ documentReferences, driverLicenseCategories, onSubmit, initialState, onClose, onDelete, status = 'closed', blockBackground, trackSaveButtonClick, trackCancelButtonClick, trackModalShow, trackModalConfirm, trackModalCancel, trackSaveFail, trackCloseClick, }) => {
    const formRef = useRef(null);
    const [confirmationStatus, setConfirmationStatus] = useState('disable');
    const handleSubmit = async () => {
        formRef.current && formRef.current.requestSubmit();
    };
    const handleSave = () => {
        trackSaveButtonClick && trackSaveButtonClick();
        handleSubmit();
    };
    const handleCancel = () => {
        trackCancelButtonClick && trackCancelButtonClick();
        onClose();
    };
    const handleModalConfirm = () => {
        trackModalConfirm && trackModalConfirm();
        setConfirmationStatus('hide');
        handleSubmit();
    };
    const handleModalCancel = () => {
        trackModalCancel && trackModalCancel();
        onClose();
    };
    const handleCompareWithInitial = (initial, current) => {
        if (!initial) {
            if (!current.code || !current.number) {
                setConfirmationStatus('disable');
            }
            else {
                setConfirmationStatus('hide');
            }
            return;
        }
        if (JSON.stringify(initial) === JSON.stringify(current)) {
            setConfirmationStatus('disable');
        }
        else {
            setConfirmationStatus('hide');
        }
    };
    const handleClose = () => {
        trackCloseClick && trackCloseClick();
        if (confirmationStatus === 'hide') {
            trackModalShow && trackModalShow();
            setConfirmationStatus('show');
        }
        else {
            onClose();
        }
    };
    useEffect(() => {
        if (status === 'closed') {
            setConfirmationStatus('disable');
        }
    }, [status]);
    if (status === 'closed') {
        return null;
    }
    return (_jsxs(SidePage, { onClose: handleClose, ignoreBackgroundClick: true, blockBackground: blockBackground, width: 700, className: classes.identityDocumentSidePage, children: [_jsx(SidePage.Header, { children: initialState ? 'Редактирование документа' : 'Новый документ' }), _jsx(SidePage.Body, { children: _jsxs(SidePage.Container, { children: [_jsx(IdentityDocumentForm, { ref: formRef, documentReferences: documentReferences, driverLicenseCategories: driverLicenseCategories, initialState: initialState, onSubmit: onSubmit, disabled: status === 'saving' || status === 'deleting', onCompareWithInitial: handleCompareWithInitial, trackSaveFail: trackSaveFail }), confirmationStatus === 'show' && (_jsxs(Modal, { onClose: () => { setConfirmationStatus('hide'); }, width: 474, children: [_jsx(Modal.Header, { children: initialState ? 'Сохранить изменения?' : 'Сохранить новый документ?' }), _jsxs(Modal.Body, { children: ["\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C ", initialState ? 'изменения в этом документе' : 'этот документ', ' ', "\u0438\u043B\u0438\u00A0\u0437\u0430\u043A\u0440\u044B\u0442\u044C \u0435\u0433\u043E \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F"] }), _jsx(Modal.Footer, { children: _jsxs(Gapped, { children: [_jsx(Button, { onClick: handleModalConfirm, use: "primary", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), _jsx(Button, { onClick: handleModalCancel, children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F" })] }) })] }))] }) }), _jsx(SidePage.Footer, { panel: true, children: _jsxs("div", { className: classes.footer, children: [_jsxs(Gapped, { className: classes.footerLeft, children: [_jsx(Button, { onClick: handleSave, loading: status === 'saving', disabled: status === 'deleting', use: "primary", size: "medium", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), _jsx(Button, { onClick: handleCancel, size: "medium", disabled: status === 'saving' || status === 'deleting', children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })] }), initialState && (_jsx(Button, { onClick: onDelete, size: "medium", icon: status === 'deleting' ? undefined : _jsx(TrashCanIcon, {}), disabled: status === 'saving', loading: status === 'deleting', children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }))] }) })] }));
};
